<template>
  <vue-countdown :time="remainingSeconds" :transform="padWithZeroes" v-slot="{ days, hours, minutes, seconds }" class="countdown">
    <span class="part">
      <span class="value">{{ days }}</span>
      <span class="label">DAGER</span>
    </span>
    <span class="sep">:</span>
    <span class="part">
      <span class="value">{{ hours }}</span>
      <span class="label">TIMER</span>
    </span>
    <span class="sep">:</span>
    <span class="part">
      <span class="value">{{ minutes }}</span>
      <span class="label">MINUTTER</span>
    </span>
    <span class="sep">:</span>
    <span class="part">
      <span class="value">{{ seconds }}</span>
      <span class="label">SEKUNDER</span>
    </span>
  </vue-countdown>
</template>

<script>
  import VueCountdown from '@chenfengyuan/vue-countdown'

  export default {
    name: 'ExpanderCountdow',
    components: {
      VueCountdown,
    },
    props: {
      date: { type: String, required: true },
    },
    computed: {
      remainingSeconds: function () {
        return new Date(this.date) - new Date()
      },
    },
    methods: {
      padWithZeroes(date) {
        date.hours = date.hours < 10 ? `0${date.hours}` : date.hours
        date.minutes = date.minutes < 10 ? `0${date.minutes}` : date.minutes
        date.seconds = date.seconds < 10 ? `0${date.seconds}` : date.seconds
        return date
      },
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/mixins.scss';

  .countdown {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sep {
    display: none;
  }
  .part {
    width: 4.125rem;
    text-align: center;
    line-height: .5;
  }
  .value {
    display: block;
    line-height: 1;
    font-size: 2.5rem;
  }
  .label {
    font-size: .75rem;
  }

</style>
